export function isNumeric(str: string): boolean {
  return !isNaN(Number(str)) && !isNaN(parseFloat(str));
}

export function ellipsizeText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  const ellipsis = "...";
  const half = Math.floor((maxLength - ellipsis.length) / 2);
  return `${text.slice(0, half)}${ellipsis}${text.slice(text.length - half)}`;
}

export function getFileName(fileName: string): string {
  const dotIndex = fileName.lastIndexOf(".");
  return dotIndex === -1 ? fileName : fileName.substring(0, dotIndex);
}

export function getFileExt(fileName: string): string {
  const dotIndex = fileName.lastIndexOf(".");
  return dotIndex === -1 ? "" : fileName.substring(dotIndex + 1);
}
